/**
 * App.jsx
 * Root component. Wraps the portal in MSAL context.
 * Handles the three authentication states:
 *   1. Loading  — MSAL is initializing (SSO silent check in progress)
 *   2. Signed out — show sign-in prompt
 *   3. Authenticated — render the portal
 */

import React from "react";
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import Portal from "./components/Portal";
import "./styles/index.css";

// ── Sign-in screen (shown when unauthenticated) ────────────────────────────
function SignIn() {
  const { instance } = useMsal();

  function handleSignIn() {
    instance.loginRedirect(loginRequest).catch(err => {
      console.error("[Portal] Login redirect failed:", err);
    });
  }

  return (
    <div className="signin-screen">
      <div className="signin-card">
        <div className="signin-card__logo-row">
          <span className="signin-card__logo">H2</span>
        </div>
        <h1 className="signin-card__title">H2 Fin Platform</h1>
        <p className="signin-card__sub">
          Sign in with your Harness Financial Microsoft account to access your workspace.
        </p>
        <button className="btn btn--primary" onClick={handleSignIn}>
          <svg width="20" height="20" viewBox="0 0 21 21" fill="none" aria-hidden="true">
            {/* Microsoft logo mark */}
            <rect x="1"  y="1"  width="9" height="9" fill="#F25022"/>
            <rect x="11" y="1"  width="9" height="9" fill="#7FBA00"/>
            <rect x="1"  y="11" width="9" height="9" fill="#00A4EF"/>
            <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
          </svg>
          Sign in with Microsoft
        </button>
        <p className="signin-card__note">
          MFA is required. Have your Microsoft Authenticator app ready.
        </p>
      </div>
      <footer className="signin-footer">
        H2 Fin · apps.h2fin.com · Secured by Microsoft Entra ID
      </footer>
    </div>
  );
}

// ── Root ───────────────────────────────────────────────────────────────────
export default function App({ msalInstance }) {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthenticatedTemplate>
        <Portal />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <SignIn />
      </UnauthenticatedTemplate>
    </MsalProvider>
  );
}
